module.exports = __webpack_public_path__ + "static/media/cooperation.dfffee97.png";